module.exports = __webpack_public_path__ + "img/page5.202766ee.png";